'use client';
import React, { useEffect, useRef, useState } from 'react';

function useInView(threshold = 0.1) {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {if (entry.isIntersecting) setInView(true);},
      { threshold }
    );
    if (ref?.current) observer?.observe(ref?.current);
    return () => observer?.disconnect();
  }, [threshold]);
  return { ref, inView };
}

const accordionItems = [
{
  id: 'collapse1',
  icon: "https://img.rocket.new/generatedImages/rocket_gen_img_13b37e553-1772489245852.png",
  title: 'Prenez rendez-vous',
  body: 'Contactez-nous par téléphone ou en ligne pour planifier votre consultation. Notre secrétariat médical vous accueille du lundi au samedi de 8h00 à 20h00.'
},
{
  id: 'collapse2',
  icon: "https://img.rocket.new/generatedImages/rocket_gen_img_1b1f8b2f5-1785328108132.png",
  title: 'Consultation & Diagnostic',
  body: 'Nos médecins généralistes et spécialistes réalisent une consultation approfondie, établissent un diagnostic précis et élaborent un plan de soins personnalisé.'
},
{
  id: 'collapse3',
  icon: "https://img.rocket.new/generatedImages/rocket_gen_img_11e0c0fc3-1785328106545.png",
  title: 'Suivi & Soins Continus',
  body: 'COSA assure un suivi préventif et thérapeutique complet incluant diététique, kinésithérapie, optique et analyses biomédicales pour votre bien-être durable.'
}];


export default function HowItWork() {
  const { ref, inView } = useInView();
  const [openItem, setOpenItem] = useState<string>('collapse1');

  return (
    <div className="how-it-work">
      <div className="dentaire-container">
        <div className="row align-items-center" ref={ref}>
          {/* Left Image */}
          <div className="col-lg-6">
            <div className="how-it-work-img">
              <figure className="reveal image-anime" style={{ display: 'block', overflow: 'hidden', borderRadius: '40px' }}>
                <img
                  src="/assets/images/how-it-work-img.png"
                  alt="Processus de soins au centre COSA"
                  style={{ aspectRatio: '1/1.05', objectFit: 'cover', borderRadius: '40px', width: '100%', display: 'block' }} />
                
              </figure>
            </div>
          </div>

          {/* Right Content */}
          <div className="col-lg-6">
            <div className="how-it-work-content">
              <div className="section-title">
                <h3
                  style={{
                    opacity: inView ? 1 : 0,
                    transform: inView ? 'translateY(0)' : 'translateY(20px)',
                    transition: 'opacity 0.6s ease, transform 0.6s ease'
                  }}>
                  comment ça marche</h3>
                <h2
                  style={{
                    opacity: inView ? 1 : 0,
                    transform: inView ? 'translateY(0)' : 'translateY(20px)',
                    transition: 'opacity 0.6s ease 0.1s, transform 0.6s ease 0.1s'
                  }}>
                  
                  <span>Notre Processus</span> de Soins en 3 Étapes
                </h2>
                <p
                  style={{
                    marginTop: '20px',
                    marginBottom: 0,
                    opacity: inView ? 1 : 0,
                    transform: inView ? 'translateY(0)' : 'translateY(20px)',
                    transition: 'opacity 0.6s ease 0.25s, transform 0.6s ease 0.25s'
                  }}>
                  
                  COSA s'appuie sur un modèle d'exécution rigoureux avec des processus définis pour garantir la qualité des soins médicaux et paramédicaux à chaque étape de votre parcours de santé.
                </p>
              </div>

              {/* Accordion */}
              <div className="faq-accordion how-work-accordion" id="accordion">
                {accordionItems?.map((item, i) =>
                <div
                  key={item?.id}
                  className="accordion-item"
                  style={{
                    opacity: inView ? 1 : 0,
                    transform: inView ? 'translateY(0)' : 'translateY(20px)',
                    transition: `opacity 0.6s ease ${i * 0.25}s, transform 0.6s ease ${i * 0.25}s`
                  }}>
                  
                    <div className="icon-box">
                      <img src={item?.icon} alt={item?.title} />
                    </div>
                    <h2 className="accordion-header">
                      <button
                      className={`accordion-button${openItem !== item?.id ? ' collapsed' : ''}`}
                      onClick={() => setOpenItem(openItem === item?.id ? '' : item?.id)}>
                      
                        {item?.title}
                      </button>
                    </h2>
                    <div
                    className={`accordion-collapse collapse${openItem === item?.id ? ' show' : ''}`}
                    style={{ display: openItem === item?.id ? 'block' : 'none' }}>
                    
                      <div className="accordion-body">
                        <p>{item?.body}</p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>);

}